import { Navigate } from "react-router-dom";
import { EKAM_LEGAL_PAGES } from "../data/ekamLegal";
import { EkamSiteFooter, EkamSiteHeader } from "../components/EkamSite";
import { AskEkamWidget } from "../components/AskEkam";

const Section = ({ section }) => (
  <section className="mt-10">
    <h2 className="font-display text-2xl font-light text-white">{section.heading}</h2>
    {(section.body || []).map((paragraph, i) => (
      <p key={i} className="mt-4 text-sm leading-relaxed text-slate-400">{paragraph}</p>
    ))}
    {section.list && (
      <ul className="mt-4 space-y-2">
        {section.list.map((item, i) => (
          <li key={i} className="flex gap-3 text-sm leading-relaxed text-slate-400">
            <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-cyan-400" />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    )}
    {section.table && (
      <div className="mt-5 overflow-x-auto rounded-2xl border border-teal-500/10">
        <table className="w-full text-left text-xs">
          <thead>
            <tr className="border-b border-teal-500/10 bg-white/[0.03]">
              {section.table.headers.map((header) => <th key={header} className="px-4 py-3 font-semibold uppercase tracking-wider text-cyan-300">{header}</th>)}
            </tr>
          </thead>
          <tbody>
            {section.table.rows.map((row, i) => (
              <tr key={i} className="border-b border-teal-500/5 last:border-0">
                {row.map((cell, j) => <td key={j} className={`px-4 py-3 ${j === 0 ? "font-medium text-slate-200" : "text-slate-400"}`}>{cell}</td>)}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </section>
);

export default function EkamLegal({ page }) {
  const content = EKAM_LEGAL_PAGES[page];
  if (!content) return <Navigate to="/ekam/privacy" replace />;
  return (
    <div className="min-h-screen bg-[#041718] text-slate-300" data-testid={`ekam-legal-${page}`}>
      <EkamSiteHeader title={content.title} />
      <main className="mx-auto max-w-4xl px-6 pb-10">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-cyan-300">Ekam Legal</p>
        <h1 className="mt-4 font-display text-4xl font-light text-white sm:text-5xl">{content.title}</h1>
        <p className="mt-3 text-xs uppercase tracking-[0.15em] text-slate-500">{content.subtitle}</p>
        {content.sections.map((section) => <Section key={section.heading} section={section} />)}
      </main>
      <EkamSiteFooter />
      <AskEkamWidget />
    </div>
  );
}
